export default "__VITE_ASSET__Cb7DMQiR__"